import { useState, useEffect } from "react";
import IpService from "services/ipService";

/**
 * Hook to get and manage user's IP address
 */
const useUserIp = () => {
	const [userIp, setUserIp] = useState(IpService.getCachedIp());
	const [isLoading, setIsLoading] = useState(!userIp);
	const [error, setError] = useState(null);

	useEffect(() => {
		let isMounted = true;

		const detectIp = async () => {
			try {
				setIsLoading(true);
				setError(null);

				const ip = await IpService.getUserIp();

				if (isMounted) {
					setUserIp(ip);
				}
			} catch (err) {
				if (isMounted) {
					setError(err.message);
					console.error("IP detection failed:", err);
				}
			} finally {
				if (isMounted) {
					setIsLoading(false);
				}
			}
		};

		if (!userIp) {
			detectIp();
		} else {
			setIsLoading(false);
		}

		return () => {
			isMounted = false;
		};
		// eslint-disable-next-line
	}, []);

	const refreshIp = async () => {
		IpService.clearCache();
		setUserIp(null);
		setIsLoading(true);
		setError(null);

		try {
			const ip = await IpService.getUserIp();
			setUserIp(ip);
		} catch (err) {
			setError(err.message);
		} finally {
			setIsLoading(false);
		}
	};

	return {
		userIp,
		isLoading,
		error,
		refreshIp,
	};
};

export default useUserIp;
